// HomeNerdlet.jsx
import React, { useState, useContext } from "react";
import i18n from "./i18n/i18n";
import MarketWiseStatus from "./MarketWiseStatus";
import LanguageSwitcher from "./LanguageSwitcher";
import MarketSwitcher from "./MarketSwitcher";
//import { I18nextProvider } from "react-i18next";
import { AccountProvider } from "./account-context";
import { PlatformStateContext,AccountsQuery, UserQuery } from "nr1";
import AlertsPanel from "./AlertsPanel";
import OperationalHealth from "./OperationalHealth";
import GlobalDashboard from "./GlobalDashboard/GlobalDashboard";
import { MarketProvider } from "./contexts/MarketContext";
import { PreferencesProvider } from "./contexts/PreferencesContext";
import DashboardRouter from "./DashboardRouter";
function HomeNerdlet() {
  const [language, setLanguage] = useState("en");

  const [market, setMarket] = useState("3592556");

  const platformState = useContext(PlatformStateContext);
  //const accountId = platformState?.accountId ?? null;
  const accountId = market;
  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
  };

  
  //const selectedAccountId = 4091918;//platformState?.context?.accountId || accountId;


  return (

    <UserQuery>
      {({ loading, error, data }) => {
        if (loading) return <p>Loading user…</p>;
        if (error) return <p>Error loading user</p>;

        const { email } = data;

        return (
          // Preferences wrap the market context, which restores the last route
          // from them on a cold load.
          <PreferencesProvider userKey={email}>
            <MarketProvider>
              <DashboardRouter userEmail={email} language={language} setLanguage={setLanguage} />
            </MarketProvider>
          </PreferencesProvider>
      //     <AccountProvider
      //       accountId={accountId}
      //       userEmail={email}
      //       language={language}
      //       setLanguage={setLanguage}
      //     >
      //       <header className="header-row">
      //         <div className="header-actions">
      //           {/* <LanguageSwitcher value={language} onChange={setLanguage} /> */}
      //           <MarketSwitcher value={market} onChange={setMarket} />
      //         </div>
      //       </header>

      //       {/* <MarketWiseStatus
      //   lang={language}
      //   onChangeLanguage={handleLanguageChange}
      // />  */}

      //       <OperationalHealth />
      //     </AccountProvider>
        );
      }}
    </UserQuery>
  );
}

export default HomeNerdlet;
